/* eslint arrow-body-style: 0 */
import KanbanView from './components/KanbanView.vue';
import DashboardView from './components/DashboardView.vue';
import { frontendURL } from '../../../helper/URLHelper';
import ListFunnelView from './components/ListFunnelView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'crm',
    roles: ['administrator', 'agent'],
    component: KanbanView,
  },
  {
    path: frontendURL('accounts/:accountId/crm/tickets/:ticketId'),
    name: 'crm_ticket',
    roles: ['administrator', 'agent'],
    component: KanbanView,
    props: route => {
      return { ticketId: route.params.ticketId };
    },
  },
  {
    path: frontendURL('accounts/:accountId/crm/dashboard'),
    name: 'crm_dashboard',
    roles: ['administrator', 'agent'],
    component: DashboardView,
  },
  // {
  //   path: frontendURL('accounts/:accountId/crm/funnel'),
  //   name: 'funnel',
  //   roles: ['administrator', 'agent'],
  //   component: ListFunnelView,
  // },
];
